export default __webpack_public_path__ + "static/media/Connector_Type1.70ad7be0.svg";